<!--
    // ACHTUNG: 
    // Eine sehr ähnliche Logik gibt es in Map.buildMarkerIconHTML()
    // Bei Änderungen immer BEIDES ÄNDERN!
-->                        
                        
                        <span class="fa-stack fa-2x" style="width: 100%;">
                            <i class="fa fa-map-marker fa-stack-2x" style="color: {{farbeRahmen}}; font-size: 1.75em; margin-top: -3px; margin-left: -2.5px;"></i>
                            <i class="fa fa-map-marker fa-stack-2x" style="color: {{farbe}}; font-size: 1.5em;"></i>
                            <i class="fa fa-{{icon}} fa-stack-1x" style="color: white; font-size: 0.5em; margin-left: 0.625em; margin-top: -0.625em;"></i>
                        </span>   